const sortValue = (event) => {
  if (typeof event.sortKey === "number") return event.sortKey;
  const yearMatch = `${event.years || ""}`.match(/\d{4}/);
  return yearMatch ? Number(yearMatch[0]) : 0;
};

const sortTimelineNodes = (nodes) => {
  nodes.sort((left, right) => sortValue(left) - sortValue(right));
  nodes.forEach((node) => sortTimelineNodes(node.nestedEvents));
  return nodes;
};

export const buildTimelineTree = (events = []) => {
  const nodes = events.map((event, index) => ({
    ...event,
    id: event.id || `timeline-event-${index + 1}`,
    nestedEvents: [],
  }));
  const nodesById = new Map(nodes.map((event) => [event.id, event]));
  const roots = [];

  nodes.forEach((event) => {
    const parent = event.parentId ? nodesById.get(event.parentId) : null;
    if (parent && parent !== event) parent.nestedEvents.push(event);
    else roots.push(event);
  });

  return sortTimelineNodes(roots);
};
